export const LABEL_QUERY_KEYS = {
  LABELS: 'labels',
};

export type TLabel = {
  id: string;
  name: string;
};

export type TCreateLabel = {
  name: string;
};
